import { ButtonBase } from '@mui/material';
import { FaCheckLightSvgIcon } from '../../../assets/icons/svgs';
import { UserLocation } from '../../../redux/user/userSlice';
import { colors } from '../../../theme/colors';
import spacing from '../../../theme/spacing';
import { fontSize } from '../../../theme/typography';
import { useTranslation } from 'react-i18next';
import { MIN_LOCATION_ITEM_HEIGHT } from '../styles';
import LocationItemTypeIcon from '../LocationItemTypeIcon';
import LocationItemContent from '../LocationItemContent';

interface LocationSelectItemProps {
  handleModalClose: () => void;
  onSelection: (location: UserLocation) => void;

  location: UserLocation;
  selectedLocation?: UserLocation;
}

const LocationSelectItem = ({
  location,
  selectedLocation,
  onSelection,
  handleModalClose,
}: LocationSelectItemProps) => {
  const { t, i18n } = useTranslation();
  const isSelected = selectedLocation?.id === location.id;

  const SelectedIcon = () => {
    if (!isSelected) {
      return null;
    }
    return (
      <FaCheckLightSvgIcon
        size={fontSize['3xl']}
        style={{
          color: colors.primary,
        }}
      />
    );
  };

  const DefaultIndicator = () => {
    if (!location.default) {
      return null;
    }
    return (
      <div
        style={{
          color: colors.textGreyMedium,
          fontSize: fontSize.sm,
          display: 'inline-block',
          marginLeft: spacing.small,
        }}
      >
        {t('common.default')}
      </div>
    );
  };

  return (
    <ButtonBase
      key={location.id}
      onClick={() => {
        onSelection(location);
        handleModalClose();
      }}
      style={{
        paddingTop: spacing.medium,
        paddingBottom: spacing.medium,
        background: 'transparent',
        display: 'block',
        width: '100%',
        textAlign: 'left',
        minHeight: MIN_LOCATION_ITEM_HEIGHT,
        borderBottom: `1px solid ${colors.backgroundSuperLight}`,
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
          }}
        >
          <div
            style={{
              display: 'inline-block',
              marginRight: spacing.medium,
            }}
          >
            <LocationItemTypeIcon location={location} isSelected={isSelected} />
          </div>
          <div
            style={{
              display: 'inline-block',
            }}
          >
            <LocationItemContent location={location} isSelected={isSelected} />
          </div>
        </div>

        <div
          style={{
            display: 'inline-flex',
            alignItems: 'center',
          }}
        >
          <SelectedIcon />
          <DefaultIndicator />
        </div>
      </div>
    </ButtonBase>
  );
};

export default LocationSelectItem;
